// Mirror of the lambda's `appendShareId` (longlinks_shortener/api/helpers.js).
// Idempotent: re-running overwrites the existing `share_id` query param.
//
// We pass a dummy base so `new URL()` accepts relative paths too — the
// front-end occasionally hands us one (e.g. tests, vanity links).
export function appendShareId(longUrl: string, shareId: string): string {
	const parsed = new URL(longUrl, 'https://dummy.invalid');
	parsed.searchParams.set('share_id', shareId);
	return parsed.toString().replace('https://dummy.invalid', '');
}
